import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
import PlainTitleText from "@/components/plainTitleText/PlainTitleText.vue";
import AnimatedNumber from "animated-number-vue";

export default {
    name: "Benefits",
    props: {
        titleNumberResults: {type: String, default: ""},
        subtitleNumberResults: {type: String, default: ""},
        titleTextResults: {type: String, default: ""},
        subtitleTextResults: {type: String, default: ""},
        greyBenefits: {type: Boolean},
        numberResults: {
            type: Array, default: function () {
                return []
            }
        },
        textResults: {
            type: Array, default: function () {
                return []
            }
        }
    },
    data() {
        var rows = (this.textResults.length >= 4) ? 2 : 1
        var slidesToShow = (rows > 1) ? 2 : this.textResults.length
        return {
            carouselSettings: {
                arrows: true,
                dots: false,
                slidesToShow: this.textResults.length,
                slidesToScroll: this.textResults.length,
                responsive: [
                    {
                        breakpoint: 1024,
                        settings: {
                            dots: true,
                            arrows: false,
                            slidesToShow: slidesToShow,
                            rows: rows,
                            adaptiveHeight: true,
                            centerMode: true
                        }
                    },
                    {
                        breakpoint: 768,
                        settings: {
                            dots: true,
                            arrows: false,
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }
                    }
                ]
            }
        }
    },
    computed: {},
    mounted() {
    },
    created: function () {
        $(document).ready(function () {
            setCarouselHeight($(document));
            $(window).on('resize', debounce(function () {
                setCarouselHeight($(this));
            }));
        });

        var setCarouselHeight = function (doc) {
            if (doc.width() > 768 && doc.width() <= 1024) {
                $(".benefits .text-results").height(Math.max.apply(null, $(".benefits .text-results").map(function () {
                    return $(this).height();
                }).get()));
            } else {
                $(".benefits .text-results").css("height", "initial");
            }
        }

        var debounce = function (func) {
            var timer;
            return function (event) {
                if (timer) clearTimeout(timer);
                timer = setTimeout(func, 100, event);
            };
        }
    },
    components: {
        VueSlickCarousel,
        PlainTitleText,
        AnimatedNumber
    },
    methods: {
        splitStringAndNumber(number) {
            let regexAllNumber = /[-0-9.,]+/;
            let allNumber = number.match(regexAllNumber);
            allNumber = (allNumber && allNumber[0]) ? allNumber[0] : '';
            allNumber = String(allNumber.replace(',', '.'));

            let numberOfDecimal = (allNumber.includes('.')) ? 10 : 1;

            let regexAllStrings = /[a-zA-Z%\s]+/;
            let allStrings = number.match(regexAllStrings);
            allStrings = (allStrings && allStrings[0]) ? allStrings[0] : '';
            
            return {
                number: allNumber,
                numberOfDecimal: numberOfDecimal,
                string: allStrings
            };
        }
    }
}

